export const SizeScreen = {
  NORMAL: 0,
  IS_TABLET: 1,
  IS_MOBILE: 2,
};
